import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';
import { 
  Box, 
  Tabs, 
  Tab, 
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import ReportIcon from '@mui/icons-material/Assessment';
import { ListAlt } from '@mui/icons-material';
import ViewListIcon from '@mui/icons-material/ViewList';
import SettingsIcon from '@mui/icons-material/Settings';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import { paths } from '../routes/paths';

const DockContainer = styled(Paper)(({ theme }) => ({
  position: 'sticky',
  top: 64,
  zIndex: 8,
  width: '95%', 
  margin: '0 auto',
  borderRadius: theme.spacing(2), 
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', 
  marginBottom: theme.spacing(3),
}));


const JobsDock = ({ jobId }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const tabs = [
    {
      text: "Job Application",
      icon: <DescriptionIcon />,
      path: jobId ? `${paths.dashboard.applications}/${jobId}` : paths.dashboard.applications,
    },
    {
      text: "Resume Dashboard",
      icon: <ReportIcon />,
      path: jobId ? `${paths.dashboard.reports}/${jobId}` : paths.dashboard.reports,
    },
    {
      text: "Screening Dashboard",
      icon: <PhoneCallbackIcon />,
      path: jobId ? `${paths.dashboard.screening}/${jobId}` : paths.dashboard.screening,
    },
    {
      text: "Interview Dashboard",
      icon: <ListAlt />,
      path: jobId ? `${paths.dashboard.interviews}/${jobId}` : paths.dashboard.interviews,
    },
    {
      text: "Interview Config",
      icon: <SettingsIcon />,
      path: jobId ? `${paths.dashboard.interviewConfig}/${jobId}` : paths.dashboard.interviewConfig,
    },
    {
      text: "Ranking",
      icon: <ViewListIcon />,
      path: jobId ? `${paths.dashboard.rankings}/${jobId}` : paths.dashboard.rankings,
    }
  ];

  // Find which tab is currently active
  const currentPath = location.pathname;
  const getActiveTabIndex = () => {
    const activeTabIndex = tabs.findIndex(tab => 
      currentPath.includes(tab.path.split('/').slice(-2)[0])
    );
    return activeTabIndex >= 0 ? activeTabIndex : 0;
  };

  const handleTabChange = (event, newValue) => {
    navigate(tabs[newValue].path);
  };
  
  return (
    <DockContainer>
      <Box sx={{ px: 2, borderColor: 'divider' }}>

        <Tabs 
          value={getActiveTabIndex()} 
          onChange={handleTabChange}
          variant={isMobile ? "scrollable" : "fullWidth"}
          scrollButtons={isMobile ? "auto" : false}
          aria-label="job management tabs"
        >
          {tabs.map((tab, index) => (
            <Tab 
              key={index}
              icon={tab.icon}
              label={tab.text}
              iconPosition="start"
              sx={{ 
                minHeight: '56px',
                textTransform: 'none'
              }}
            />
          ))}
        </Tabs>
      </Box>
    </DockContainer>
  );
};

export default JobsDock;